import { XMLParser } from 'fast-xml-parser';

import { readCSV } from './readCSV.js';
import { readTimeCSV } from './readTimeCSV.js';

export function tripleDetectionAgilent(basic, processed, cumulative, xml) {
  basic = readTimeCSV(basic);
  processed = readTimeCSV(processed);
  cumulative = readCSV(cumulative);

  const xmlParser = new XMLParser();
  const parsed = xmlParser.parse(xml);
  return { basic, processed, cumulative, xml: parsed };
}
